<template>
  <a-layout class='index animated fadeIn'>
    <SmallSquare content='黑名单上的用户将无法参与各种营销活动及云店商品购买和积分兑换行为等，黑名单身份可撤销。' :padding='true'></SmallSquare>
    <a-card :bordered="false">
      <a-form ref='form' :model='search' :initialValues="search"
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="拉黑时间" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <!-- <a-form-item label="标签" name='level'>
          <a-select v-model:value="search.level" :style="{width:'180px'}" placeholder="全部">
            <a-select-option value="shanghai">
              全部
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="所在地区" name='district_id'>
          <selectCity v-on:citychange='cityChange' placeholder="所在地区" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
          <!-- <a-button htmlType='submit' class='m-r-10'>重置</a-button> -->
         <a-button class='m-r-10' v-has:memberBackExport="exportTable">导出</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-20'>
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='member_id' :columns='columns' :data-source='data'>
          <template v-slot:action="{ record }">
              <a v-has:memberBackDel="()=>revoke(record)" href="javascript:;">撤销黑名单</a>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
          :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
          @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
      </div>
    </a-card>
  </a-layout>
</template>
<script>
  import { DownOutlined } from "@ant-design/icons-vue";
  import { reactive, ref, toRefs,h } from "vue";
  import { getPointLog } from "@/api/assets";
  import { iscode } from "@/utils/app";
  import { getMemberBlackList, delMemberBlack } from '@/api/member'
  import { message,Modal } from "ant-design-vue";
  const def = {
    page: 1,
    limit: 10,
    start_time:'',
    end_time:'',
    district_id:''
  }
  export default {
    // components: { DownOutlined },
    name: "integralDetail",
    setup() {
      const state = reactive({
        listLoading: false,
        total: 0,
        time:[]
      });
      let data = ref();
      let columns = [
        {
          title: "用户ID",
          dataIndex: "member_id",
          key: "member_id",
        },
        {
          title: "用户昵称",
          dataIndex: "member_name",
          key: "member_name",
          customRender: ({ record }) => {
            return record.member_name ? record.member_name : '-'
          },
        },
        {
          title: "会员等级",
          dataIndex: "vip_level_name",
          key: "vip_level_name",
        },
        {
          title: "可用积分",
          dataIndex: "point",
          key: "point",
        },
        {
          title: "手机号码",
          dataIndex: "phone",
          key: "phone",
          customRender: ({ record }) => {
            return record.phone ? record.phone : '-'
          },
        },
        {
          title: "操作",
          key: "action",
          width: 120,
          slots: { customRender: "action" },
        },
      ];
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getMemberBlackList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.list;
          state.total = res.data.total;
        }
        state.listLoading = false;
      };
      const search = ref({...def});
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //时间选择
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
      // 地区选择
      const cityChange = (e) =>{
        search.value.district_id = e[2]
      } 
      const revoke = async(e) => {
        Modal.confirm({
          centered: true,
          width: 500,
          title: '撤销黑名单',
          content: h('div', {}, [
            h('p', { className: 'm-b-15' },
            '确定将该用户撤销黑名单吗？'),
            h('p', '撤销黑名单后，该用户将正常参与所有活动及商品购买行为！')
          ]),
          onOk: async () => {
            let res = await delMemberBlack({member_id:e.member_id}).then((res) => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          },
        });
      }
      initData(search.value);
                                // 导出
    const exportTable=async ()=>{
        let res = await getMemberBlackList({...search.value,excel:1}).then(res=>res.data);
        if(iscode(res,true)){
          window.open(res.data.action)
        }
    }
      return {
        ...toRefs(state),
        exportTable,
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        revoke,
        cityChange,
        onChange
      };
    },
  };
</script>